import React from 'react';
import { cn } from '@/lib/utils';

interface DailyCardProps {
  day: string;
  status?: string;
  score?: string;
  stars?: number;
  isCompleted?: boolean;
  isLocked?: boolean;
  isViewMore?: boolean;
  onClick?: () => void;
  className?: string;
}

export function DailyCard({
  day,
  status,
  score,
  stars = 0,
  isCompleted = false,
  isLocked = false,
  isViewMore = false,
  onClick,
  className
}: DailyCardProps) {
  
  if (isViewMore) {
    return (
      <button
        onClick={onClick}
        className={cn(
          'relative bg-white rounded-lg p-2 sm:p-3 md:p-4 text-center border-2 border-border',
          'transition-all duration-200 aspect-square',
          'flex flex-col justify-center items-center cursor-pointer',
          'hover:border-border-hover hover:-translate-y-px',
          className
        )}
      >
        <span className="text-xl">→</span>
      </button>
    );
  }
  
  return (
    <button
      onClick={!isLocked ? onClick : undefined}
      disabled={isLocked}
      className={cn(
        'relative bg-white rounded-lg p-2 sm:p-3 md:p-4 text-center border-2 border-border',
        'transition-all duration-200 aspect-square',
        'flex flex-col justify-center items-center',
        'hover:border-border-hover hover:-translate-y-px',
        {
          'bg-[#E8F5E9] border-[#4CAF50]': isCompleted,
          'opacity-60 cursor-not-allowed': isLocked,
          'cursor-pointer': !isLocked && !isCompleted
        },
        className
      )}
    >
      {isLocked && (
        <span className="absolute top-2 right-2 text-xs">🔒</span>
      )}
      
      <div className="font-oswald font-bold text-xs sm:text-sm uppercase tracking-[0.5px] sm:tracking-[1px] mb-1 sm:mb-2">
        {day}
      </div>
      
      <div className="text-[10px] sm:text-[11px] text-muted-foreground">
        {status || (isCompleted || isLocked ? score : '--')}
      </div>
      
      {(isCompleted || isLocked) && (
        <div className="text-[10px] sm:text-sm text-[#C5A572] tracking-[1px] sm:tracking-[2px] mt-0.5 sm:mt-1">
          {'★'.repeat(stars)}{'☆'.repeat(3 - stars)}
        </div>
      )}
    </button>
  );
}